import { Component, Input, OnInit } from '@angular/core';
import { Job, JobWeatherInfo } from '../../job.model';
import { UtilsService } from '../../../../../core/utils/utils.service';
import { LoggerService } from '../../../../../core/logger/logger.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { NotificationService } from '../../../../../core/notification/notification.service';
import { FormGroup } from '@angular/forms';

import { Geolocation } from '@capacitor/geolocation';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-job-weather',
    templateUrl: './job-weather.component.html',
    styleUrls: ['./job-weather.component.scss'],
})
export class JobWeatherComponent {
    @Input() job: Job;
    @Input() changesAllowed: boolean;

    loading = false;
    offlineError = false;

    constructor(
        private utils: UtilsService,
        private http: HttpClient,
        private logger: LoggerService,
        private notify: NotificationService,
        private translate: TranslateService
    ) {}

    /**
     * Triggered if the user wants to load the weather now
     */
    loadWeatherNow() {
        this.loading = true;
        this.offlineError = false;
        this.logger.log('[JOB WEATHER] trying to load weather now');

        Geolocation.getCurrentPosition({ timeout: 15000 })
            .then((location) => {
                this.logger.log('[JOB WEATHER] got current geolocation', location);

                if (this.utils.isOnline) {
                    this.logger.log('[JOB WEATHER] sending request to weather api');
                    // send api call to weather api
                    this.http
                        .get(
                            environment.OWM_API_URL +
                                '?lat=' +
                                location.coords.latitude +
                                '&lon=' +
                                location.coords.longitude +
                                `&units=metric&lang=de&exclude=minutely,hourly,daily,alerts&appid=` +
                                environment.OWM_API_KEY
                        )
                        .subscribe(
                            (res) => {
                                this.logger.log('[JOB WEATHER] got weather api response', res);
                                this.job.weather.date = Date.now();
                                this.job.weather.lat = location.coords.latitude;
                                this.job.weather.lng = location.coords.longitude;
                                this.job.weather.weatherInfo = res;
                                this.loading = false;
                            },
                            (err) => {
                                this.loading = false;
                                this.logger.error('[JOB WEATHER] could not get weather', err);
                                this.notify.error(
                                    this.translate.instant('projects.jobs.details.weather.errors.load-weather'),
                                    this.translate.instant('projects.jobs.details.weather.errors.err-title')
                                );
                            }
                        );
                } else {
                    this.loading = false;
                    this.logger.error('[JOB WEATHER] could not get weather because device is offline');
                    this.notify.error(
                        this.translate.instant('projects.jobs.details.weather.errors.load-weather'),
                        this.translate.instant('projects.jobs.details.weather.errors.no-internet')
                    );
                }
            })
            .catch((locationErr) => {
                this.logger.error('[JOB WEATHER] could not get current geolocation', locationErr);
                this.notify.error(this.translate.instant('projects.jobs.details.weather.errors.position'));
                this.utils.sentryCaptureException(locationErr);
                this.loading = false;
            });
    }
}
